import CardContents from "@ifca-root/react-component/src/components/CardList/CardContents";
import { CommonDialogV2 } from "@ifca-root/react-component/src/components/Dialog/CommonDialogV2";
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';

interface DialogProps {
	openSubDialog: boolean;
	setOpenSubDialog: any;
  subsRemainingDays:any;
  endDate: string
}
export const SubsExpReminderDialog = (props: DialogProps) => {
  const { openSubDialog, setOpenSubDialog, subsRemainingDays, endDate } = props; 

  let history = useHistory();

  return (
    <>
      <CommonDialogV2
        fullWidth={true}
        open={openSubDialog}
        onClose={() => {setOpenSubDialog(false)
          localStorage.removeItem('subsAccDetail')
        }
  }
        sections={{
          header: {
            dynamic: (
              <div className="">
                <div className="dialog-dynamic-content">
                  <div className="session">
                    <div className="title">Subscription Expiring</div>
                  </div>
                </div>
              </div>
            ),
          },
          body: () => (
            <>
              <CardContents>
                <span className="mdDesc" style={{ whiteSpace: 'initial' }}>
                {`Your application subscription will expire on ${endDate}. Please contact IFCA for renewal as soon as possible to avoid any interruptions.`}
            </span>
              </CardContents>
            </>
          ),
          footer: {
            actions: [
              {
                displayText: 'Dismiss',
                props: {
                  onClick: () => {setOpenSubDialog(false);
                    localStorage.removeItem('subsAccDetail');
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
    </>
  );
};
